<template>
	<div class="product">
		<v-col class="pt-5">
			<v-row v-if="detailProduct.product">
				<v-col cols="12" sm="5" md="5">
					<v-card outlined class="rounded-lg">
						<v-col class="my-auto pa-1">
							<div class="images cursor-pointer" v-viewer="{movable: false, toolbar: false, fullscreen: true, toolbar: false, title:false}">
								<img width="100%" class="rounded-lg" :src="imageSelected">
							</div>
						</v-col>
					</v-card>
					<div class="pt-3">
						<carousel :loop="false" :nav="false" :dots="false" :responsive="{0:{items:4},600:{items:4},1000:{items:4}}" :margin="10" v-if="detailProduct.product.product_image.length > 0">
							<div class="pr-2" v-for="(image, i) in detailProduct.product.product_image" :key="i">
								<v-card outlined class="rounded-lg" @click="defaultImage = image">
									<v-col class="my-auto pa-1">
										<v-img width="100%" class="rounded-lg" :src="image"></v-img>
									</v-col>
								</v-card>
							</div>
						</carousel>
					</div>
				</v-col>
				<v-col cols="12" sm="7" md="7" class="pt-0 pt-sm-4 pb-0 pb-sm-3">
					<!-- <div><img width="130" src="/assets/icons/pasaroa-green.svg"></div> -->
					<div class="pt-2 d-flex justify-space-between">
						<div class="text-body-1 text-sm-h6 font-weight-bold text-uppercase">{{ detailProduct.product.product_name }}</div>
						<div class="text-body-1 text-sm-h6 font-weight-bold">Rp {{ detailProduct.product.product_price | toNumber }} <sup v-if="detailProduct.product.product_price != detailProduct.product.product_price_origin" class="text-decoration-line-through font-size-10 pink--text">{{detailProduct.product.product_price_origin | toNumber}}</sup></div>
					</div>
					<div class="text-body-2" v-if="detailProduct.product.product_pv > 0">{{ detailProduct.product.product_pv | toNumber }} PV</div>
					<div class="text-body-2 text-sm-body-1 pt-2"></div>
					<div class="text-body-2 pt-2 line-height-18-rem">
						<span class="white-space-preline" v-html="detailProduct.product.product_description" v-if="detailProduct.product.product_description"></span>
						<div v-else>
							<v-alert class="text-body-2" text color="primary">
								Produk belum memiliki deskripsi
							</v-alert>
						</div>
					</div>
					<div class="pt-5">
						<v-btn x-large block depressed color="primary" class="text-body-2 font-weight-bold rounded-lg" @click="scrollStore">Pilih Toko</v-btn>
					</div>
				</v-col>
			</v-row>
			<div class="pt-5 available-store">
				<div class="text-body-1 text-sm-h6 text-uppercase primary--text">Toko Yang Tersedia</div>
			</div>
			<div class="pt-3">
				<v-row>
					<v-col cols="2" class="pr-0 d-none d-md-block">
						<div class="pt-3"></div>
						<div class="d-flex font-weight-bold">
							<v-icon color="">mdi-filter</v-icon>
							<div class="pl-2 text-uppercase">Filter</div>
						</div>
						<div class="pt-3 text-body-2">
							<v-expansion-panels tile multiple accordion v-model="panel" class="accordion-filter">
								<v-expansion-panel v-if="false">
									<v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2">Lokasi</v-expansion-panel-header>
									<v-expansion-panel-content>
										<v-checkbox class="mt-0 small-check" hide-details label="Yogyakarta"></v-checkbox>
										<v-checkbox class="mt-0 small-check" hide-details label="Semarang"></v-checkbox>
										<v-checkbox class="mt-0 small-check" hide-details label="Solo"></v-checkbox>
									</v-expansion-panel-content>
								</v-expansion-panel>
								<v-expansion-panel>
									<v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2">Cari Toko</v-expansion-panel-header>
									<v-expansion-panel-content>
										<div class="pt-2">
											<v-text-field v-model="storeNameFilter.value" outlined dense hide-details placeholder="Nama Toko" class="rounded-lg text-body-2"></v-text-field>
										</div>
										<div class="pt-2">
											<v-btn color="primary" width="100%" @click="cari" depressed class="rounded-lg font-weight-bold">Terapkan</v-btn>
										</div>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</v-col>
					<v-col cols="12" md="10" class="pl-md-5 pt-0 pt-md-3">
						<div>
							<v-row class="px-3 pb-3 d-flex d-md-none">
								<v-col cols="12" class="pa-0">
									<div class="pt-1">
										<v-text-field hide-details placeholder="Cari Toko" append-icon="mdi-magnify" outlined dense class="rounded-lg text-body-2"></v-text-field>
									</div>
								</v-col>
							</v-row>
							<v-list class="py-0">
								<v-list-item dense class="px-0" v-if="false">
									<div class="pt-1">
										<div class="font-weight-bold text-body-2">Urutkan :</div>
									</div>
									<div class="pt-1 ml-2">
										<v-autocomplete outlined dense hide-details placeholder="Urutkan dari" class="rounded-lg text-body-2" height="45" no-data-text="Belum ada data tersedia"></v-autocomplete>
									</div>
								</v-list-item>
							</v-list>
						</div>
						<div class="pt-md-5">
							<div v-if="store.length > 0">
								<v-row class="ml-0">
									<v-col class="pl-0 pt-0" cols="6" sm="4" md="3" v-for="(data, i) in store" :key="i">
										<v-hover v-slot:default="{ hover }">
											<router-link :to="{ name: 'product-detail',params: { id: data.product_id, slug: data.product_slug_name } }" class="text-deco">
												<v-card outlined class="rounded-lg" :elevation="hover ? 4 : 0">
													<div class="pa-3">
														
													</div>
													<v-img width="100%" :src="data.store_image ? data.store_image : '/assets/seller/default-toko.svg'" height="150" class="rounded-lg"></v-img>
													<v-col class="grey--text text--darken-2 text-body-2 text-center">
														<div class="font-weight-bold text-uppercase">{{ data.store_name }}</div>
														<div class="pt-1 font-weight-bold">{{ data.user_mobilephone }}</div>
														<div class="pt-2 primary--text text--darken-2">{{ data.store_city_name }}</div>
													</v-col>
												</v-card>
											</router-link>
										</v-hover>
									</v-col>
								</v-row>
								<v-row class="pt-4 justify-center">
									<v-pagination v-if="storePagination.total_page > 1" v-model="page" @input="changePage" :length="storePagination.total_page" class="elevation-0"></v-pagination>
								</v-row>
							</div>
							<div v-else>
								<v-row class="justify-center">
									<v-col cols="7" md="4">
										<v-img width="100%" src="/assets/icons/ilus-transaksi-kosong.svg"></v-img>
									</v-col>
								</v-row>
								<div class="text-center pb-3">
									<div class="pt-1 text-body-2 text-md-body-1 font-weight-bold">Belum ada toko yang menjual produk ini.</div>
								</div>
							</div>
						</div>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import $ from 'jquery';
import { mapState, mapActions } from 'vuex'

export default {
	components: {
		carousel
	},
	data() {
		return {
			defaultImage: '',
			panel: [0, 1],
			page: 1,
			limit: 5,
			storeNameFilter: {
				value: '',
				comparison: 'like',
				type: 'string',
				field: 'store_name',
			},
			params:[]
		}
	},
	computed: {
		...mapState('productExternal', ['detailProduct']),
		...mapState('store', ['store', 'storePagination']),

		imageSelected() {
			let image = "/assets/product/default.png"
			if (this.detailProduct.product) {
				if (this.defaultImage) {
					image = this.defaultImage
				} else {
					image = this.detailProduct.product.product_image[0] ? this.detailProduct.product.product_image[0] : image
				}
			}
			return image
		}
	},
	methods: {
		...mapActions('productExternal', ['getDetailProduct']),
		...mapActions('store', ['getStoreByInternal']),

		changePage() {
			let param = this.queryString({
				page: this.page,
				params: this.params,
				sort: this.sortBy,
				dir: this.sortDir,
			})
			param['product_id'] = this.$route.params.id
			this.getStoreByInternal(param)
		},
		cari() {
			this.params = []
			if (this.storeNameFilter.value)
				this.params.push(this.storeNameFilter)

			this.page = 1
			let param = this.queryString({
				limit: this.limit,
				page: this.page,
				params: this.params,
				sort: this.sortBy,
				dir: this.sortDir,
			})
			param['product_id'] = this.$route.params.id
			this.getStoreByInternal(param)
		},
		scrollStore() {
			var as = $('.available-store').offset().top;
			as -= 90;
			$('html').scrollTop(as);
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Produk Ekslusif');
		this.getDetailProduct({
			slug: this.$route.params.slug,
			id: this.$route.params.id
		}).then( () => {
			this.getStoreByInternal({
				product_id: this.$route.params.id
			})
		})
	}
};
</script>